import styled from 'styled-components/macro';
import { Card } from 'components/Card/Card.styles';

export const OrderSummaryCard = styled(Card)`
  border-color: var(--primary-400);
  overflow: hidden;
`;
